import React, { memo } from "react";

const RadioButtonGroup = ({
  name,
  id,
  label = '',
  selectedValue,
  handleChange = null,
  options,
  required,
  disabled,
  errorMessage,
  isShowError = true
}) => {
  return (
    <div>
      <label className="form-label col-form-label w-100 fs-5 form-label-custom-visible">
        {label} {required && <span className="mandatory">*</span>}
      </label>
      <div className="d-flex gap-3-3 flex-wrap mt--10" >
        {options?.map((option, index) => (
          <div key={option.value} className="form-check">
            <input
              type="radio"
              className="form-check-input"
              name={name}
              id={`${name}-${option.value}-${index}`}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={(e) => handleChange(e)}
              disabled={disabled}
              style={
                errorMessage && errorMessage[name]
                  ? { borderColor: "#c8605e" }
                  : {}
              }
            />
            <label
              className="form-check-label fs-5 form-label-custom-visible"
              htmlFor={`${name}-${option.value}-${index}`}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>

      {/* Display error message */}
      {<div className="text-danger-new fw-bold fs-6 mt-1">
        {errorMessage && errorMessage[name] && errorMessage[name]}
      </div>}
    </div>

  );
};



export default memo(RadioButtonGroup);
